import marked from 'marked'

// 配置 marked：开启 GFM（表格、删除线等）和换行转 <br>
marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  mangle: false
})

// 需要在文本提取前转换为换行的块级元素标签
var BLOCK_TAGS = ['P', 'DIV', 'LI', 'TR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE', 'PRE', 'HR', 'SECTION', 'ARTICLE', 'HEADER', 'FOOTER']
var BLOCK_SELECTOR = BLOCK_TAGS.join(',')

/**
 * 将 Markdown 文本转换为纯文本
 * @param {string} md - Markdown 源文本
 * @returns {string} 去除所有 Markdown 标记的纯文本，保留段落间换行
 */
export function markdownToPlainText(md) {
  if (!md) return ''
  var content = md
  // 1. 剥离自定义的 <options> 标签
  content = content.replace(/<options>[\s\S]*?<\/options>/g, '')

  // 2. 用 marked 转为 HTML
  var html
  try {
    html = marked.parse(content)
  } catch (e) {
    console.error('Markdown 转纯文本失败:', e)
    return content.trim()
  }

  // 3. 创建临时 DOM 提取纯文本，处理块级元素换行
  var container = document.createElement('div')
  container.innerHTML = html

  // 在块级元素前插入换行符，保证段落分隔
  var blocks = container.querySelectorAll(BLOCK_SELECTOR)
  for (var i = 0; i < blocks.length; i++) {
    blocks[i].insertAdjacentText('beforebegin', '\n')
  }
  // <br> 替换为换行
  var brs = container.querySelectorAll('br')
  for (var j = 0; j < brs.length; j++) {
    brs[j].insertAdjacentText('beforebegin', '\n')
  }

  // 4. 提取 textContent
  var text = container.textContent || ''

  // 5. 清理：压缩连续 3 个以上换行为 2 个，去除行首尾空白，去除首尾空行
  text = text.replace(/\n{3,}/g, '\n\n').split('\n').map(function (line) {
    return line.replace(/\s+$/g, '')
  }).join('\n').replace(/^\s+|\s+$/g, '')

  return text
}
